import { aboutInfo } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900">关于我们</h2>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-10">
          <div className="max-w-3xl mx-auto">
            {aboutInfo.paragraphs.map((paragraph, idx) => (
              <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4 last:mb-0">
                {paragraph}
              </p>
            ))}

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mt-8 pt-8 border-t border-background-200/70">
              {aboutInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-black text-primary-500">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}